// extracted by mini-css-extract-plugin
module.exports = {"bidHistoryWrapper":"BidHistoryBtn_bidHistoryWrapper__3Zsy9","bidHistory":"BidHistoryBtn_bidHistory__2lmSd"};